import { render, staticRenderFns } from "./CreateProjectDialog.vue?vue&type=template&id=bd5f652c"
import script from "./CreateProjectDialog.vue?vue&type=script&lang=js"
export * from "./CreateProjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports